var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "naver_ad_header" }, [
    _c("strong", { staticClass: "search_keyword" }, [
      _vm._v(_vm._s(_vm.searchQuery) + " 관련 광고")
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ad_mark_wrap" }, [
      _c("i", { staticClass: "ico_info", on: { click: _vm.toggleInfo } })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info_desc", class: { show: _vm.isInfoVisible } },
      [
        _c("button", {
          staticClass: "btn_close_info",
          attrs: { type: "button", "aria-label": "광고 정보 닫기" },
          on: { click: _vm.closeInfo }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "divider" }),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: _vm.helpUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }
          },
          [_vm._v("도움말")]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("광고 노출기준은 검색어에 대한 연관성과"),
      _c("br"),
      _vm._v("광고주의 입찰가이며, 이미지 등 추가 링크는 등록한"),
      _c("br"),
      _vm._v("\n\t      경우에만 기준에 따라 노출됩니다.\n      ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }